"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_2b1yv347bs = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/authentication/Authentication.js";
  var hash = "871af88e291620e37b912b4214dc1e0f0d74ebde";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/authentication/Authentication.js",
    statementMap: {
      "0": {
        start: {
          line: 23,
          column: 28
        },
        end: {
          line: 23,
          column: 38
        }
      },
      "1": {
        start: {
          line: 25,
          column: 17
        },
        end: {
          line: 27,
          column: 4
        }
      },
      "2": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 15
        }
      },
      "3": {
        start: {
          line: 29,
          column: 31
        },
        end: {
          line: 40,
          column: 32
        }
      },
      "4": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 38,
          column: 5
        }
      },
      "5": {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 33,
          column: 7
        }
      },
      "6": {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 24
        }
      },
      "7": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 37,
          column: 7
        }
      },
      "8": {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 35,
          column: 17
        }
      },
      "9": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 31
        }
      },
      "10": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 28
        }
      },
      "11": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 48,
          column: 45
        }
      },
      "12": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 47,
          column: 5
        }
      },
      "13": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 46,
          column: 9
        }
      },
      "14": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 45,
          column: 67
        }
      },
      "15": {
        start: {
          line: 45,
          column: 29
        },
        end: {
          line: 45,
          column: 67
        }
      },
      "16": {
        start: {
          line: 50,
          column: 19
        },
        end: {
          line: 90,
          column: 3
        }
      },
      "17": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 89,
          column: 5
        }
      },
      "18": {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 15
        }
      },
      "19": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 55,
          column: 29
        }
      },
      "20": {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 88,
          column: 7
        }
      },
      "21": {
        start: {
          line: 58,
          column: 31
        },
        end: {
          line: 60,
          column: 10
        }
      },
      "22": {
        start: {
          line: 61,
          column: 8
        },
        end: {
          line: 61,
          column: 43
        }
      },
      "23": {
        start: {
          line: 63,
          column: 8
        },
        end: {
          line: 76,
          column: 9
        }
      },
      "24": {
        start: {
          line: 64,
          column: 34
        },
        end: {
          line: 64,
          column: 48
        }
      },
      "25": {
        start: {
          line: 66,
          column: 10
        },
        end: {
          line: 75,
          column: 11
        }
      },
      "26": {
        start: {
          line: 67,
          column: 12
        },
        end: {
          line: 67,
          column: 23
        }
      },
      "27": {
        start: {
          line: 68,
          column: 12
        },
        end: {
          line: 68,
          column: 49
        }
      },
      "28": {
        start: {
          line: 70,
          column: 12
        },
        end: {
          line: 74,
          column: 13
        }
      },
      "29": {
        start: {
          line: 71,
          column: 14
        },
        end: {
          line: 71,
          column: 38
        }
      },
      "30": {
        start: {
          line: 72,
          column: 19
        },
        end: {
          line: 74,
          column: 13
        }
      },
      "31": {
        start: {
          line: 73,
          column: 14
        },
        end: {
          line: 73,
          column: 38
        }
      },
      "32": {
        start: {
          line: 78,
          column: 29
        },
        end: {
          line: 78,
          column: 60
        }
      },
      "33": {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 82,
          column: 9
        }
      },
      "34": {
        start: {
          line: 81,
          column: 10
        },
        end: {
          line: 81,
          column: 39
        }
      },
      "35": {
        start: {
          line: 84,
          column: 8
        },
        end: {
          line: 86,
          column: 9
        }
      },
      "36": {
        start: {
          line: 85,
          column: 10
        },
        end: {
          line: 85,
          column: 40
        }
      },
      "37": {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 87,
          column: 31
        }
      },
      "38": {
        start: {
          line: 92,
          column: 2
        },
        end: {
          line: 100,
          column: 4
        }
      },
      "39": {
        start: {
          line: 103,
          column: 0
        },
        end: {
          line: 127,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "Authentication",
        decl: {
          start: {
            line: 10,
            column: 9
          },
          end: {
            line: 10,
            column: 23
          }
        },
        loc: {
          start: {
            line: 22,
            column: 3
          },
          end: {
            line: 101,
            column: 1
          }
        },
        line: 22
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 25,
            column: 29
          },
          end: {
            line: 25,
            column: 30
          }
        },
        loc: {
          start: {
            line: 25,
            column: 35
          },
          end: {
            line: 27,
            column: 3
          }
        },
        line: 25
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 29,
            column: 43
          },
          end: {
            line: 29,
            column: 44
          }
        },
        loc: {
          start: {
            line: 29,
            column: 54
          },
          end: {
            line: 40,
            column: 3
          }
        },
        line: 29
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 34,
            column: 21
          },
          end: {
            line: 34,
            column: 22
          }
        },
        loc: {
          start: {
            line: 34,
            column: 27
          },
          end: {
            line: 37,
            column: 7
          }
        },
        line: 34
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 42,
            column: 12
          },
          end: {
            line: 42,
            column: 13
          }
        },
        loc: {
          start: {
            line: 42,
            column: 18
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 42
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 44,
            column: 21
          },
          end: {
            line: 44,
            column: 22
          }
        },
        loc: {
          start: {
            line: 44,
            column: 40
          },
          end: {
            line: 46,
            column: 7
          }
        },
        line: 44
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 50,
            column: 19
          },
          end: {
            line: 50,
            column: 20
          }
        },
        loc: {
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 90,
            column: 3
          }
        },
        line: 52
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 11,
            column: 11
          },
          end: {
            line: 18,
            column: 8
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 18,
            column: 6
          },
          end: {
            line: 18,
            column: 8
          }
        }],
        line: 11
      },
      "1": {
        loc: {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 12,
            column: 24
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 12,
            column: 17
          },
          end: {
            line: 12,
            column: 24
          }
        }],
        line: 12
      },
      "2": {
        loc: {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 13,
            column: 60
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 13,
            column: 19
          },
          end: {
            line: 13,
            column: 60
          }
        }],
        line: 13
      },
      "3": {
        loc: {
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 14,
            column: 46
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 14,
            column: 20
          },
          end: {
            line: 14,
            column: 46
          }
        }],
        line: 14
      },
      "4": {
        loc: {
          start: {
            line: 15,
            column: 4
          },
          end: {
            line: 15,
            column: 42
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 15,
            column: 20
          },
          end: {
            line: 15,
            column: 42
          }
        }],
        line: 15
      },
      "5": {
        loc: {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 16,
            column: 86
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 19
          },
          end: {
            line: 16,
            column: 86
          }
        }],
        line: 16
      },
      "6": {
        loc: {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 17,
            column: 71
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 17,
            column: 18
          },
          end: {
            line: 17,
            column: 71
          }
        }],
        line: 17
      },
      "7": {
        loc: {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        }, {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        }],
        line: 30
      },
      "8": {
        loc: {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 33,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 33,
            column: 7
          }
        }, {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 33,
            column: 7
          }
        }],
        line: 31
      },
      "9": {
        loc: {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        }, {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        }],
        line: 43
      },
      "10": {
        loc: {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 45,
            column: 67
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 45,
            column: 67
          }
        }, {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 45,
            column: 67
          }
        }],
        line: 45
      },
      "11": {
        loc: {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 89,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 89,
            column: 5
          }
        }, {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 89,
            column: 5
          }
        }],
        line: 53
      },
      "12": {
        loc: {
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 76,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 76,
            column: 9
          }
        }, {
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 76,
            column: 9
          }
        }],
        line: 63
      },
      "13": {
        loc: {
          start: {
            line: 66,
            column: 10
          },
          end: {
            line: 75,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 10
          },
          end: {
            line: 75,
            column: 11
          }
        }, {
          start: {
            line: 66,
            column: 10
          },
          end: {
            line: 75,
            column: 11
          }
        }],
        line: 66
      },
      "14": {
        loc: {
          start: {
            line: 66,
            column: 14
          },
          end: {
            line: 66,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 14
          },
          end: {
            line: 66,
            column: 18
          }
        }, {
          start: {
            line: 66,
            column: 22
          },
          end: {
            line: 66,
            column: 27
          }
        }],
        line: 66
      },
      "15": {
        loc: {
          start: {
            line: 70,
            column: 12
          },
          end: {
            line: 74,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 12
          },
          end: {
            line: 74,
            column: 13
          }
        }, {
          start: {
            line: 70,
            column: 12
          },
          end: {
            line: 74,
            column: 13
          }
        }],
        line: 70
      },
      "16": {
        loc: {
          start: {
            line: 72,
            column: 19
          },
          end: {
            line: 74,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 19
          },
          end: {
            line: 74,
            column: 13
          }
        }, {
          start: {
            line: 72,
            column: 19
          },
          end: {
            line: 74,
            column: 13
          }
        }],
        line: 72
      },
      "17": {
        loc: {
          start: {
            line: 78,
            column: 29
          },
          end: {
            line: 78,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 78,
            column: 46
          },
          end: {
            line: 78,
            column: 55
          }
        }, {
          start: {
            line: 78,
            column: 58
          },
          end: {
            line: 78,
            column: 60
          }
        }],
        line: 78
      },
      "18": {
        loc: {
          start: {
            line: 78,
            column: 29
          },
          end: {
            line: 78,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 78,
            column: 29
          },
          end: {
            line: 78,
            column: 30
          }
        }, {
          start: {
            line: 78,
            column: 34
          },
          end: {
            line: 78,
            column: 43
          }
        }],
        line: 78
      },
      "19": {
        loc: {
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 82,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 82,
            column: 9
          }
        }, {
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 82,
            column: 9
          }
        }],
        line: 80
      },
      "20": {
        loc: {
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 86,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 86,
            column: 9
          }
        }, {
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 86,
            column: 9
          }
        }],
        line: 84
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0],
      "5": [0],
      "6": [0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "871af88e291620e37b912b4214dc1e0f0d74ebde"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("../../core");

var _LoginForm = require("./LoginForm");

var _helpers = require("./helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function Authentication(_ref) {
  var _ref$messages = _ref.messages;
  _ref$messages = _ref$messages === void 0 ? (cov_2b1yv347bs.b[0][0]++, {}) : _ref$messages;
  var _ref$messages$actionT = _ref$messages.actionText,
      actionText = _ref$messages$actionT === void 0 ? (cov_2b1yv347bs.b[1][0]++, 'Login') : _ref$messages$actionT,
      _ref$messages$generic = _ref$messages.genericError,
      genericError = _ref$messages$generic === void 0 ? (cov_2b1yv347bs.b[2][0]++, 'Something went wrong, please try again.') : _ref$messages$generic,
      _ref$messages$usernam = _ref$messages.usernameError,
      usernameError = _ref$messages$usernam === void 0 ? (cov_2b1yv347bs.b[3][0]++, 'Username does not exist.') : _ref$messages$usernam,
      _ref$messages$passwor = _ref$messages.passwordError,
      passwordError = _ref$messages$passwor === void 0 ? (cov_2b1yv347bs.b[4][0]++, 'Password is invalid.') : _ref$messages$passwor,
      _ref$messages$network = _ref$messages.networkError,
      networkError = _ref$messages$network === void 0 ? (cov_2b1yv347bs.b[5][0]++, 'There is an issue with your network connection. Please try again.') : _ref$messages$network,
      _ref$messages$serverE = _ref$messages.serverError,
      serverError = _ref$messages$serverE === void 0 ? (cov_2b1yv347bs.b[6][0]++, 'There is an issue with the server please try again.') : _ref$messages$serverE,
      authentication = _ref.authentication,
      onAuthentication = _ref.onAuthentication,
      config = _ref.config;
  cov_2b1yv347bs.f[0]++;

  var _ref2 = (cov_2b1yv347bs.s[0]++, (0, _react.useState)()),
      _ref3 = _slicedToArray(_ref2, 2),
      error = _ref3[0],
      setError = _ref3[1];

  var logout = (cov_2b1yv347bs.s[1]++, (0, _react.useCallback)(function () {
    cov_2b1yv347bs.f[1]++;
    cov_2b1yv347bs.s[2]++;
    (0, _helpers.saveAuth)();
  }));
  var updateAuthentication = (cov_2b1yv347bs.s[3]++, (0, _react.useCallback)(function (_auth) {
    cov_2b1yv347bs.f[2]++;
    cov_2b1yv347bs.s[4]++;

    if (_auth) {
      cov_2b1yv347bs.b[7][0]++;
      cov_2b1yv347bs.s[5]++;

      if (_auth.remember) {
        cov_2b1yv347bs.b[8][0]++;
        cov_2b1yv347bs.s[6]++;
        (0, _helpers.saveAuth)(_auth);
      } else {
        cov_2b1yv347bs.b[8][1]++;
      }

      cov_2b1yv347bs.s[7]++;

      _auth.logout = function () {
        cov_2b1yv347bs.f[3]++;
        cov_2b1yv347bs.s[8]++;
        logout();
        cov_2b1yv347bs.s[9]++;
        updateAuthentication();
      };
    } else {
      cov_2b1yv347bs.b[7][1]++;
    }

    cov_2b1yv347bs.s[10]++;
    onAuthentication(_auth);
  }, [logout, onAuthentication]));
  cov_2b1yv347bs.s[11]++;
  (0, _react.useEffect)(function () {
    cov_2b1yv347bs.f[4]++;
    cov_2b1yv347bs.s[12]++;

    if (!authentication) {
      cov_2b1yv347bs.b[9][0]++;
      cov_2b1yv347bs.s[13]++;
      (0, _helpers.getAuth)().then(function (_authentication) {
        cov_2b1yv347bs.f[5]++;
        cov_2b1yv347bs.s[14]++;

        if (_authentication) {
          cov_2b1yv347bs.b[10][0]++;
          cov_2b1yv347bs.s[15]++;
          updateAuthentication(_authentication);
        } else {
          cov_2b1yv347bs.b[10][1]++;
        }
      });
    } else {
      cov_2b1yv347bs.b[9][1]++;
    }
  }, [authentication, updateAuthentication]);
  cov_2b1yv347bs.s[16]++;

  var onSubmit = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref4) {
      var username, password, remember, _authentication2, _ref6, user, token, errorMessage;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              username = _ref4.username, password = _ref4.password, remember = _ref4.remember;
              cov_2b1yv347bs.f[6]++;
              cov_2b1yv347bs.s[17]++;

              if (!authentication) {
                _context.next = 11;
                break;
              }

              cov_2b1yv347bs.b[11][0]++;
              cov_2b1yv347bs.s[18]++;
              logout();
              cov_2b1yv347bs.s[19]++;
              updateAuthentication();
              _context.next = 45;
              break;

            case 11:
              cov_2b1yv347bs.b[11][1]++;
              cov_2b1yv347bs.s[20]++;
              _context.prev = 13;
              cov_2b1yv347bs.s[21]++;
              _context.next = 17;
              return (0, _core.authenticate)({
                username: username,
                password: password,
                config: config
              });

            case 17:
              _authentication2 = _context.sent;
              cov_2b1yv347bs.s[22]++;
              _authentication2.remember = remember;
              cov_2b1yv347bs.s[23]++;

              if (_authentication2) {
                cov_2b1yv347bs.b[12][0]++;
                _ref6 = (cov_2b1yv347bs.s[24]++, _authentication2), user = _ref6.user, token = _ref6.token;
                cov_2b1yv347bs.s[25]++;

                if ((cov_2b1yv347bs.b[14][0]++, user) && (cov_2b1yv347bs.b[14][1]++, token)) {
                  cov_2b1yv347bs.b[13][0]++;
                  cov_2b1yv347bs.s[26]++;
                  setError();
                  cov_2b1yv347bs.s[27]++;
                  updateAuthentication(_authentication2);
                } else {
                  cov_2b1yv347bs.b[13][1]++;
                  cov_2b1yv347bs.s[28]++;

                  if (!user) {
                    cov_2b1yv347bs.b[15][0]++;
                    cov_2b1yv347bs.s[29]++;
                    setError(usernameError);
                  } else {
                    cov_2b1yv347bs.b[15][1]++;
                    cov_2b1yv347bs.s[30]++;

                    if (!token) {
                      cov_2b1yv347bs.b[16][0]++;
                      cov_2b1yv347bs.s[31]++;
                      setError(passwordError);
                    } else {
                      cov_2b1yv347bs.b[16][1]++;
                    }
                  }
                }
              } else {
                cov_2b1yv347bs.b[12][1]++;
              }

              _context.next = 45;
              break;

            case 24:
              _context.prev = 24;
              _context.t0 = _context["catch"](13);
              errorMessage = (cov_2b1yv347bs.s[32]++, (cov_2b1yv347bs.b[18][0]++, _context.t0) && (cov_2b1yv347bs.b[18][1]++, _context.t0.message) ? (cov_2b1yv347bs.b[17][0]++, _context.t0.message) : (cov_2b1yv347bs.b[17][1]++, ''));
              cov_2b1yv347bs.s[33]++;

              if (!errorMessage.match(_core.ERROR_SERVER_UNREACHABLE)) {
                _context.next = 34;
                break;
              }

              cov_2b1yv347bs.b[19][0]++;
              cov_2b1yv347bs.s[34]++;
              return _context.abrupt("return", setError(serverError));

            case 34:
              cov_2b1yv347bs.b[19][1]++;

            case 35:
              cov_2b1yv347bs.s[35]++;

              if (!errorMessage.match(_core.ERROR_NETWORK_DISCONNECTED)) {
                _context.next = 42;
                break;
              }

              cov_2b1yv347bs.b[20][0]++;
              cov_2b1yv347bs.s[36]++;
              return _context.abrupt("return", setError(networkError));

            case 42:
              cov_2b1yv347bs.b[20][1]++;

            case 43:
              cov_2b1yv347bs.s[37]++;
              setError(genericError);

            case 45:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[13, 24]]);
    }));

    return function onSubmit(_x) {
      return _ref5.apply(this, arguments);
    };
  }();

  cov_2b1yv347bs.s[38]++;
  return _react.default.createElement(_LoginForm.LoginForm, {
    config: config,
    authentication: authentication,
    actionText: actionText,
    errorText: error,
    onSubmit: onSubmit
  });
}

cov_2b1yv347bs.s[39]++;
Authentication.propTypes = {
  /** Pass a previously returned authentication object to bypass login. */
  authentication: _propTypes.default.shape({
    user: _propTypes.default.object.isRequired,
    token: _propTypes.default.object.isRequired,
    config: _propTypes.default.object.isRequired,
    remember: _propTypes.default.bool
  }),

  /** Callback function to propogate the user/token used for API Authentication. */
  onAuthentication: _propTypes.default.func.isRequired,

  /** Override the default text and errors. Must override all or none. */
  messages: _propTypes.default.shape({
    actionText: _propTypes.default.string.isRequired,
    genericError: _propTypes.default.string.isRequired,
    usernameError: _propTypes.default.string.isRequired,
    passwordError: _propTypes.default.string.isRequired
  }),

  /** Configuration for authentication to work, server and tokenid are required. */
  config: _propTypes.default.shape({
    /** The Gitea server to use when authenticating. */
    server: _propTypes.default.string.isRequired,

    /** The id of the token to create/retrieve that is used for the app. */
    tokenid: _propTypes.default.string.isRequired
  }).isRequired
};
var _default = Authentication;
exports.default = _default;